"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Placeholders = require("./Placeholders");

Object.keys(_Placeholders).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Placeholders[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Placeholders[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/placeholders/index.js
// module id = 761
// module chunks = 0 15 16 17 18